import React from 'react';
interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  tone?: 'light' | 'dark';
  as?: 'h2' | 'h3';
}
export function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left',
  tone = 'light',
  as: Tag = 'h2'
}: SectionHeadingProps) {
  const dark = tone === 'dark';
  return <div className={`max-w-2xl ${align === 'center' ? 'mx-auto text-center' : ''}`} data-id="element-177" data-mp="3k29liatp0f1e">
      {eyebrow && <p className={`mb-4 text-[12px] uppercase tracking-[0.2em] ${dark ? 'text-gold-300' : 'text-gold-600'}`} data-id="element-178" data-mp="gjgiut2gdam0">
          {eyebrow}
        </p>}
      <Tag className={`font-serif text-[30px] leading-[1.15] tracking-tight sm:text-[38px] ${dark ? 'text-white' : 'text-navy-950'}`} data-id="element-179" data-mp="6tn8twhyl3jv">
        {title}
      </Tag>
      {description && <p className={`mt-5 text-[17px] leading-relaxed ${dark ? 'text-navy-200' : 'text-navy-600'}`} data-id="element-180" data-mp="zahep88a0q1c">
          {description}
        </p>}
    </div>;
}